import { render, staticRenderFns } from "./ListProductsFromSearch.vue?vue&type=template&id=018624f6&"
import script from "./ListProductsFromSearch.vue?vue&type=script&lang=js&"
export * from "./ListProductsFromSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports